const handlePayloadCreator = (callback, shouldReturnCustomError = false) => async (params, { rejectWithValue }) => {
  try {
    const response = params ? await callback(params) : await callback();
    return response;
  } catch (error) {
    let errorPayload = error?.data;
    if (shouldReturnCustomError) {
      errorPayload = {
        isErrorModalOpen: true,
        message: error?.data?.message,
        title: error?.data?.title,
      };
    }
    return rejectWithValue(errorPayload, { rejected: true });
  }
};

export default handlePayloadCreator;
